
export function getEnumOptions(options: any) {
    return Object.keys(options)
        .map(key => ({ label: options[key], value: key }))
}

export function enumFormatter(enums: any) {
     return (value: any) => value in enums ? enums[value] : '';
}



// WEBPACK FOOTER //
// ./resources/js/utils/helper.ts